/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Sortasc2Inputs */

const en_columnmenu_sortasc2 = /** @type {(inputs: Columnmenu_Sortasc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort Ascending`)
};

const de_columnmenu_sortasc2 = /** @type {(inputs: Columnmenu_Sortasc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufsteigend sortieren`)
};

/**
* | output |
* | --- |
* | "Sort Ascending" |
*
* @param {Columnmenu_Sortasc2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_sortasc2 = /** @type {((inputs?: Columnmenu_Sortasc2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Sortasc2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_sortasc2(inputs)
	return de_columnmenu_sortasc2(inputs)
});
export { columnmenu_sortasc2 as "columnMenu_sortAsc" }